import { Component, Input, OnInit } from '@angular/core';
import { AssetClassTenure } from 'src/app/core/comparable';

@Component({
  selector: 'kt-leasehold-information-table',
  templateUrl: './leasehold-information-table.component.html',
  styleUrls: ['./leasehold-information-table.component.scss']
})
export class LeaseholdInformationTableComponent implements OnInit {
  @Input() tpCurrency: string;
  @Input() consideration: AssetClassTenure;
  rentType: string;
  total_consideration: number = undefined;
  capital_payment: number = undefined;
  estimated_pmf_per_month: number = undefined;
  estimated_utility_cost: number = undefined;
  estimated_fri_per_month: number = undefined;
  constructor() { }

  ngOnInit(): void {
    const isSameCurrency = this.consideration.currency === this.tpCurrency;
    const conv = this.consideration.conversion.find(c => c.quote_currency === this.tpCurrency);
    this.total_consideration = isSameCurrency
      ? this.consideration.total_consideration
      : conv 
        ? this.consideration.total_consideration * conv.exchange_rate
        : undefined;
    this.capital_payment = isSameCurrency
      ? Number(this.consideration.cap_payment)
      : conv 
        ? Number(this.consideration.cap_payment) * conv.exchange_rate
        : undefined;
    this.estimated_pmf_per_month = isSameCurrency
      ? Number(this.consideration.estimated_amount_property_management)
      : conv
        ? Number(this.consideration.estimated_amount_property_management) * conv.exchange_rate
        : undefined;
    this.estimated_utility_cost = isSameCurrency
      ? Number(this.consideration.estimated_amount_utilities_cost)
      : conv
        ? Number(this.consideration.estimated_amount_utilities_cost) * conv.exchange_rate
        : undefined;
    this.estimated_fri_per_month = isSameCurrency
      ? Number(this.consideration.estimated_amount_repair_cost)
      : conv
        ? Number(this.consideration.estimated_amount_repair_cost) * conv.exchange_rate
        : undefined;
    this.rentType = this.consideration.rent_type.charAt(0).toUpperCase() + this.consideration.rent_type.slice(1);
  }
}
